/* Collection 2026 product cards (snippets/coll-card.liquid), shared by the grid and the
   trending carousel. Photo slider arrows, progress bar, and colour swatches that swap the
   first photo and point the card links at that colour. Document-level, so cards added later
   (View More, filter reloads) work without re-binding. */
(function () {
  if (window.__c26Cards) return;
  window.__c26Cards = true;

  function updateProgress(track) {
    var card = track.closest('[data-c26-card]');
    var bar = card && card.querySelector('[data-c26-progress]');
    if (!bar) return;
    var n = track.children.length;
    var max = track.scrollWidth - track.clientWidth;
    var ratio = max > 0 ? track.scrollLeft / max : 0;
    bar.style.transform = 'translateX(' + (ratio * (n - 1) * 100) + '%)';
  }

  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-c26-track]')) updateProgress(t);
  }, true);

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var slideBtn = t.closest('[data-c26-slide]');
    if (slideBtn) {
      var track = slideBtn.closest('[data-c26-card]').querySelector('[data-c26-track]');
      var dir = parseInt(slideBtn.getAttribute('data-c26-slide'), 10);
      var w = track.clientWidth;
      var target = Math.round(track.scrollLeft / w) + dir;
      if (target < 0) target = track.children.length - 1;
      if (target > track.children.length - 1) target = 0;
      track.scrollTo({ left: target * w, behavior: 'smooth' });
      return;
    }

    var swatch = t.closest('[data-c26-swatch]');
    if (swatch) {
      e.preventDefault();
      var card = swatch.closest('[data-c26-card]');
      card.querySelectorAll('[data-c26-swatch]').forEach(function (s) { s.classList.toggle('is-active', s === swatch); });
      var first = card.querySelector('[data-c26-track] .c26-card__img');
      if (first && swatch.dataset.src) {
        first.srcset = swatch.dataset.srcset;
        first.src = swatch.dataset.src;
      }
      card.querySelectorAll('[data-c26-link-product]').forEach(function (a) { a.href = swatch.href; });
      var tr = card.querySelector('[data-c26-track]');
      if (tr) tr.scrollTo({ left: 0, behavior: 'smooth' });
    }
  });
})();
